module.exports = "/_next/static/files/68d3d095de48c4890a4466810a742a38.jpg";